/**
 * The active section's topic list — a pill-style topic bar plus the scrollable
 * HTML content pane for whichever topic is selected.
 */
export default function HelpContent({ section, activeTopicId, onSelectTopic }) {
  const topic =
    section.topics.find((candidate) => candidate.id === activeTopicId) || section.topics[0];

  return (
    <div className="help-drawer__content">
      <div className="help-drawer__topic-pills" role="tablist" aria-label={`${section.label} topics`}>
        {section.topics.map((candidate) => (
          <button
            key={candidate.id}
            type="button"
            className={`badge rounded-pill help-drawer__pill${
              candidate.id === topic.id ? ' help-drawer__pill--active' : ''
            }`}
            data-testid={`help-topic-${candidate.id}`}
            role="tab"
            aria-selected={candidate.id === topic.id}
            onClick={() => onSelectTopic(candidate.id)}
          >
            {candidate.label}
          </button>
        ))}
      </div>

      <div className="help-drawer__body" data-testid="help-topic-body">
        <h6 className="help-drawer__topic-title">{topic.title}</h6>
        {/* Authored help copy (src/help/content.js), not user input. */}
        <div dangerouslySetInnerHTML={{ __html: topic.body }} />
      </div>
    </div>
  );
}
